export const ru = {
  common: {
    loading: 'Загрузка...',
    error: 'Ошибка',
    retry: 'Повторить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    back: 'Назад',
    next: 'Далее',
    pay: 'Оплатить',
  },
  header: {
    goToBot: 'Telegram Бот',
  },
  footer: {
    telegramBot: 'Telegram Bot',
    userAgreement: 'Пользовательское соглашение',
    support: 'Поддержка',
  },
  home: {
    title: 'Купить USDT',
    subtitle: 'Быстро, надёжно, без комиссий',
  },
  payment: {
    title: 'Оплата заказа',
    subtitle: 'Отсканируйте QR-код или нажмите кнопку для оплаты',
    waiting_payment: 'Нажмите кнопку для перехода к оплате',
    amount: 'Сумма к оплате',
    wallet: 'Кошелёк',
    network: 'Сеть',
    validUntil: 'Действительно до',
    qrHint: 'Отсканируйте QR-код в мобильном приложении банка или штатной камерой телефона. Чтобы выбрать банк вручную, нажмите кнопку «Оплатить».',
    processingHint: 'Оплата проходит через СБП. После завершения вернитесь сюда — мы автоматически обработаем платёж и отправим USDT.',
    status: {
      pending: 'Ожидает оплаты',
      waiting_payment: 'Ожидаем оплату',
      paid: 'Оплачено',
      processing: 'Обрабатывается',
      completed: 'USDT отправлен',
      failed: 'Ошибка',
      cancelled: 'Отменено',
      expired: 'Истекло',
    },
    stages: {
      paid: 'Оплата получена',
      paid_desc: 'Платёж подтверждён банком',
      processing: 'Отправляем USDT',
      processing_desc: 'Оператор формирует перевод в сети TRC-20',
      completed: 'USDT у вас',
      completed_desc: 'Средства зачислены на кошелёк',
    },
    completedTitle: 'Заказ выполнен 🎉',
    completedSubtitle: 'USDT отправлен на ваш кошелёк',
    txHashLabel: 'Транзакция',
    txHashView: 'Посмотреть в TronScan',
    txHashPending: 'Хэш появится после подтверждения в сети',
    etaHint: 'Обычно занимает 5–15 минут',
    nightHint: 'В ночное время (23:00–09:00 МСК) обработка может занять больше времени',
    stageHeader: 'Обработка заказа',
    stageSubtitle: 'Мы уже знаем об оплате и занимаемся переводом',
  },
};
